import React from "react";
import { useSelector } from "react-redux";
import { Redirect } from "react-router-dom";
import { hasTeamWorkspaceRosterAccess } from "services/utils/teamWorkspaceAccess";
import { isProvisioningLoaded } from "services/utils/HelperFunction";

// Same shape as Home/HomeAccessGate.js — generic and children-based (no
// PlanShift import here) so it's testable with a fake component, the same
// way HomeAccessGate's own test swaps in a fake Dashboard rather than
// rendering the real (heavier) TeamWorkspaceHomeContent. The actual
// PlanShift wiring lives in TeamWorkspaceRoster.js instead.
//
// The sidebar already hides Team Workspace's Rosters row without
// Rosters/Roster viewer access (Sidebar/index.js's
// TEAM_WORKSPACE_VIEWER_GATED_MODULES), but that only hides the nav link —
// Admin.js registers every route unconditionally, so a direct visit or a
// refresh while already on the page still rendered PlanShift regardless of
// that permission.
export const RosterAccessGate = ({ children }) => {
  const userScreenAccess = useSelector(
    (state) => state.tokenReducer.userScreenAccess,
  );
  const moduleDetails = userScreenAccess?.module_details;

  // Wait for permissions before deciding whether to redirect.
  // Redux holds one product's permissions at a time. Right after switching
  // into Team Workspace from another module it still holds that module's
  // (no "Home"/"Rosters" entry) until the sidebar's provisioning request
  // resolves, so judging them here bounced users to Attendance instead of
  // the Home screen they clicked (2026-10-01). Wait for Team Workspace's own.
  if (
    !isProvisioningLoaded(userScreenAccess, "Team Workspace") ||
    !Array.isArray(moduleDetails)
  ) {
    return null;
  }

  if (!hasTeamWorkspaceRosterAccess(moduleDetails)) {
    return <Redirect to="/admin/teamzone/home" />;
  }

  return children;
};
